import { render } from "./MoreInfoModal.vue?vue&type=template&id=46cfe462&scoped=true"
import script from "./MoreInfoModal.vue?vue&type=script&lang=js"
export * from "./MoreInfoModal.vue?vue&type=script&lang=js"

import "./MoreInfoModal.vue?vue&type=style&index=0&id=46cfe462&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46cfe462"]])

export default __exports__